import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { trackPageView } from '../utils/gt';
import { listKeys } from '../utils/legal';

import { LegalDoc } from '../components/LegalDoc';

// Keys under pages.Privacy, in reading order (the titles carry the section numbers)
const sections = [
  { title: 's1Title', text: 's1Text', mail: 'text', after: 's1After' },
  { title: 's2Title', text: 's2Text', items: listKeys('s2Item', 8) },
  { title: 's3Title', text: 's3Text' },
  { title: 's4Title', text: 's4Text', items: listKeys('s4Item', 8) },
  { title: 's5Title', text: 's5Text' },
  {
    title: 's6Title',
    text: 's6Text',
    items: listKeys('s6Item', 12),
    after: 's6After',
  },
  { title: 's7Title', text: 's7Text' },
  { title: 's8Title', text: 's8Text', items: listKeys('s8Item', 5) },
  { title: 's9Title', text: 's9Text' },
  { title: 's10Title', text: 's10Text' },
  { title: 's11Title', text: 's11Text' },
  {
    title: 's12Title',
    text: 's12Text',
    items: listKeys('s12Item', 8),
    after: 's12After',
    mail: 'after',
    end: 's12End',
  },
  { title: 's13Title', text: 's13Text', items: listKeys('s13Item', 5) },
  { title: 's14Title', text: 's14Text' },
];

export const Privacy = () => {
  const { t } = useTranslation();

  useEffect(() => {
    trackPageView('privacy', `${t('appUrl')}/privacy`, '/privacy');
  }, [t]);

  return <LegalDoc page="Privacy" sections={sections} />;
};
